import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UliActivityType } from '../../../common/constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-activity-type-selector',
  templateUrl: './activity-type-selector.component.html',
  styleUrls: ['./activity-type-selector.component.scss'],
})
export class ActivityTypeSelectorComponent<T> {
  @Input() activityTypeControl: FormControl<T>;
  @Input() fieldLabel: string;
  @Input() disabled = false;
  @Input() testId: string;

  uliActivityType = UliActivityType;
}
